'use strict';

(function () {
  'use strict';

  angular.module('msActivities').controller('ActivityQuizModalCtrl', ActivityQuizModalCtrl);

  ActivityQuizModalCtrl.$inject = ['quiz', 'quizLabel', 'close', '$log'];

  function ActivityQuizModalCtrl(quiz, quizLabel, close, $log) {
    var vm = this;
    vm.quiz = quiz;
    vm.quizLabel = quizLabel;
    //closeModal must be defined for base-modal
    vm.closeModal = _closeModal;

    ///////////////////
    function _closeModal(save) {
      $log.debug('ActivityQuizModalCtrl closeModal');
      // 200ms pause to let ngAnimate hide the modal.
      close(save, 200);
    }
  }
})();